import { SWC_PROMISE } from '@/data/promise';

const CONTACT_PRIMARY = import.meta.env['VITE_CONTACT_EMAIL_PRIMARY'] ?? 'kckernen@gmail.com';
const CONTACT_SECONDARY = import.meta.env['VITE_CONTACT_EMAIL_SECONDARY'] ?? 'satwell@erinind.com';
const CONTACT_HREF = `mailto:${CONTACT_PRIMARY},${CONTACT_SECONDARY}`;

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div>
          <h4>The SWC Promise</h4>
          <ul className="footer-promise">
            {SWC_PROMISE.map((p) => (
              <li key={p.title}>
                <span className="footer-promise-check">✓</span>
                <span>
                  <strong>{p.title}.</strong> {p.detail}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4>Site</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/signin">Sign In</a></li>
          </ul>
        </div>
        <div>
          <h4>Contact</h4>
          <ul>
            <li><a href={CONTACT_HREF}>Email us</a></li>
            <li><a href={CONTACT_HREF}>Authentication line</a></li>
            <li>
              <a href="https://slightlywickedcustoms.com" target="_blank" rel="noreferrer">
                slightlywickedcustoms.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="site-footer-bottom">
        <span>© 2026 Slightly Wicked Customs · Authentic Hemi · Authentically Sourced</span>
        <span>Phase 1 · MVP build</span>
      </div>
    </footer>
  );
}
